import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';

/** Wrap a page with ProtectedRoute — single place for RBAC on routes. */
export function pr(path, Page, allowedTypes, pageProps, permission, module) {
  return (
    <Route
      key={path}
      path={path}
      element={(
        <ProtectedRoute allowedTypes={allowedTypes} permission={permission} module={module}>
          {pageProps ? <Page {...pageProps} /> : <Page />}
        </ProtectedRoute>
      )}
    />
  );
}

/** Plain route without auth guard. */
export function r(path, element) {
  return <Route key={path} path={path} element={element} />;
}